export default {"src":"/_next/static/media/chicken.d974e656.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};